/* eslint-disable default-param-last */
import {
  CERT_LIST_GLOBAL_ERROR,
  SET_CERT_GLOBAL_DATE_FORMAT,
  SET_CERT_LIST_CAMPAIGNKEY,
  SET_CERT_LIST_GLOBAL_LOADING,
  SET_CERT_LIST_IS_WITHOUT_CAMPAIGN_KEY,
  SET_CERTS_TIME_ZONE,
  SET_TOUCH_DEVICE_STATUS,
  UPDATE_SCREEN_SIZE,
} from '../types';

const INITIAL_STATE = {
  mediaQueryValue: 0,
  isTouchEnabled: false,
  campaignKey: null,
  timeZone: '',
  globalDateFormat: 'MMM dd, yyyy',
  isWithoutCampaignKey: false,
  isGlobalLoading: true,
  isGlobalError: false,
  globalErrorMessage: null,
};

const globalReducer = (state = INITIAL_STATE, action) => {
  switch (action?.type) {
    case UPDATE_SCREEN_SIZE:
      return {
        ...state,
        mediaQueryValue: action?.payload,
      };

    case SET_TOUCH_DEVICE_STATUS:
      return {
        ...state,
        isTouchEnabled: action?.payload,
      };

    case SET_CERT_GLOBAL_DATE_FORMAT:
      return {
        ...state,
        globalDateFormat: action?.payload,
      };

    case SET_CERTS_TIME_ZONE:
      return {
        ...state,
        timeZone: action?.payload,
      };

    case SET_CERT_LIST_CAMPAIGNKEY:
      return {
        ...state,
        campaignKey: action?.payload,
      };

    case SET_CERT_LIST_IS_WITHOUT_CAMPAIGN_KEY:
      return {
        ...state,
        isWithoutCampaignKey: action?.payload,
      };

    case SET_CERT_LIST_GLOBAL_LOADING:
      return {
        ...state,
        isGlobalLoading: action?.payload,
      };

    case CERT_LIST_GLOBAL_ERROR:
      return {
        ...state,
        isGlobalError: action?.payload?.isError,
        globalErrorMessage: action?.payload?.error,
      };

    default:
      return state;
  }
};

export default globalReducer;
